import { render, staticRenderFns } from "./SummaryPage.vue?vue&type=template&id=31be25d7&scoped=true"
import script from "./SummaryPage.vue?vue&type=script&lang=js"
export * from "./SummaryPage.vue?vue&type=script&lang=js"
import style0 from "./SummaryPage.vue?vue&type=style&index=0&id=31be25d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be25d7",
  null
  
)

export default component.exports